import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const sendOTPApi = createApi({
  reducerPath: 'sendOTPApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['SendOTP'],
  endpoints: () => ({}),
});
